import React from 'react'

import InlineSVG from 'svg-inline-react'

import ArrowBackIcon from '~/client/static/icons/arrow-back-ios.svg'
import ArrowForwardIcon from '~/client/static/icons/arrow-forward-ios.svg'
import ArrowNextIcon from '~/client/static/icons/arrow-next.svg'
import BallInCourtIcon from '~/client/static/icons/ball-in-court.svg'
import CalendarBlankGrayIcon from '~/client/static/icons/calendar-blank-gray.svg'
import CalendarSelectedGrayIcon from '~/client/static/icons/calendar-gray-selected.svg'
import CalendarIcon from '~/client/static/icons/calendar_today.svg'
import CheckFillBlueIcon from '~/client/static/icons/check-filled-blue.svg'
import CheckSolidGreyIcon from '~/client/static/icons/check-solid-grey.svg'
import CheckPaletteBlueIcon from '~/client/static/icons/checked-palette-blue.svg'
import ClockIcon from '~/client/static/icons/clock.svg'
import CrossGreyIcon from '~/client/static/icons/close-filled-grey.svg'
import CrossIcon from '~/client/static/icons/close.svg'
import CompanyCompactIcon from '~/client/static/icons/company-compact.svg'
import CompanyIcon from '~/client/static/icons/company.svg'
import ConcreteDirectIcon from '~/client/static/icons/concrete-direct.svg'
import DeliveryIcon from '~/client/static/icons/deliveries.svg'
import DeliveryAcceptedIcon from '~/client/static/icons/delivery-accepted.svg'
import DeliveryDoneIcon from '~/client/static/icons/delivery-done.svg'
import DeliveryFailedInspectionIcon from '~/client/static/icons/delivery-failed-inspection.svg'
import DeliveryFilledIcon from '~/client/static/icons/delivery-filled.svg'
import DeliveryHeaderBarIcon from '~/client/static/icons/delivery-header-bar.svg'
import DeliveryOnsiteIcon from '~/client/static/icons/delivery-onsite.svg'
import DeliveryPassedInspectionIcon from '~/client/static/icons/delivery-passed-inspection.svg'
import DeliveryRequestedIcon from '~/client/static/icons/delivery-requested.svg'
import DeliveryUpdateIcon from '~/client/static/icons/delivery-update.svg'
import DeliveryNotificationChangedIcon from '~/client/static/icons/DeliveryNotificationChanged.svg'
import DeliveryNotificationDoneIcon from '~/client/static/icons/DeliveryNotificationDone.svg'
import DeliveryNotificationInspectionAcceptedIcon from '~/client/static/icons/DeliveryNotificationInspectionAccepted.svg'
import DeliveryNotificationInspectionRejectedIcon from '~/client/static/icons/DeliveryNotificationInspectionRejected.svg'
import DeliveryNotificationOnsiteIcon from '~/client/static/icons/DeliveryNotificationOnsite.svg'
import DeliveryNotificationScheduledIcon from '~/client/static/icons/DeliveryNotificationPlanned.svg'
import DeliveryNotificationRequestedIcon from '~/client/static/icons/DeliveryNotificationRequested.svg'
import DocsIcon from '~/client/static/icons/docs.svg'
import DoubleVerticalDotsIcon from '~/client/static/icons/double-vertical-dots.svg'
import EditActiveIcon from '~/client/static/icons/edit-blue.svg'
import EditInactiveIcon from '~/client/static/icons/edit-grey.svg'
import EditIcon from '~/client/static/icons/edit.svg'
import ExcelAppIcon from '~/client/static/icons/excel-app-icon.svg'
import EyeViewIcon from '~/client/static/icons/eye-view.svg'
import FileWordIcon from '~/client/static/icons/file-document-icon.svg'
import FileImageIcon from '~/client/static/icons/file-image-icon.svg'
import FilePdfIcon from '~/client/static/icons/file-pdf-icon.svg'
import FilePowerpointIcon from '~/client/static/icons/file-presentation-icon.svg'
import FileExcelIcon from '~/client/static/icons/file-spreadsheet-icon.svg'
import FileVideoIcon from '~/client/static/icons/file-video-icon.svg'
import FileIcon from '~/client/static/icons/file.svg'
import FilterIcon from '~/client/static/icons/filter.svg'
import HashTagIcon from '~/client/static/icons/hash-tag.svg'
import HierarchyIcon from '~/client/static/icons/hierarchy.svg'
import IdIconSrc from '~/client/static/icons/id-icon.svg'
import ListIcon from '~/client/static/icons/list.svg'
import NotReferencedIcon from '~/client/static/icons/mapbox-icons/not-referenced.svg'
import MaterialIcon from '~/client/static/icons/material.svg'
import MeasureIcon from '~/client/static/icons/measure.svg'
import LogoWithTitleIcon from '~/client/static/icons/mobile-icons/logo-with-title.svg'
import MobileIcon from '~/client/static/icons/mobile.svg'
import PDFAppIcon from '~/client/static/icons/pdf-app-icon.svg'
import PdfIcon from '~/client/static/icons/pdf-icon.svg'
import PhotoIcon from '~/client/static/icons/photo-black.svg'
import PlusIcon from '~/client/static/icons/plus.svg'
import PPTXAppIcon from '~/client/static/icons/pptx-app-icon.svg'
import ProcoreLogoIcon from '~/client/static/icons/procore-icon.svg'
import ProjectDetailsIcon from '~/client/static/icons/project-details.svg'
import ReferencedIcon from '~/client/static/icons/referenced.svg'
import RepeatIcon from '~/client/static/icons/repeat.svg'
import SharedEntityCallIcon from '~/client/static/icons/shared-entity-call-icon.svg'
import SharedEntityDotSeparatorIcon from '~/client/static/icons/shared-entity-dot-separator-icon.svg'
import SharedEntityOfficeLabelIcon from '~/client/static/icons/shared-entity-office-label-icon.svg'
import SharedEntityUserIcon from '~/client/static/icons/shared-entity-user-icon.svg'
import SharedEntityIcon from '~/client/static/icons/shared-entity.svg'
import SitemapIcon from '~/client/static/icons/sitemap.svg'
import StarFilledBigIcon from '~/client/static/icons/star-filled-big.svg'
import FilledStarIcon from '~/client/static/icons/star-filled.svg'
import StarHalfIcon from '~/client/static/icons/star-half.svg'
import StarUnfilledBigIcon from '~/client/static/icons/star-unfilled-big.svg'
import StarUnfilledInactiveBigIcon from '~/client/static/icons/star-unfilled-inactive-big.svg'
import UnfilledStarInactiveIcon from '~/client/static/icons/star-unfilled-inactive.svg'
import UnfilledStarIcon from '~/client/static/icons/star-unfilled.svg'
import LogoDarkSmallIcon from '~/client/static/icons/strux-hub-dark-small.svg'
import LogoDarkIcon from '~/client/static/icons/strux-hub-dark.svg'
import StruxHubFullIcon from '~/client/static/icons/struxhub-full.svg'
import TeamIcon from '~/client/static/icons/team.svg'
import ThreeDotsIcon from '~/client/static/icons/three-dots.svg'
import TruckIcon from '~/client/static/icons/truck-icon.svg'
import UserIcon from '~/client/static/icons/user.svg'
import VendorIcon from '~/client/static/icons/vendor.svg'
import WordAppIcon from '~/client/static/icons/word-app-icon.svg'

export function FileImage(props) {
  return <InlineSVG {...props} src={FileImageIcon} />
}

export function FileVideo(props) {
  return <InlineSVG {...props} src={FileVideoIcon} />
}

export function FilePdf(props) {
  return <InlineSVG {...props} src={FilePdfIcon} />
}

export function FileWord(props) {
  return <InlineSVG {...props} src={FileWordIcon} />
}

export function FileExcel(props) {
  return <InlineSVG {...props} src={FileExcelIcon} />
}

export function FilePowerpoint(props) {
  return <InlineSVG {...props} src={FilePowerpointIcon} />
}

export function PDFApp(props) {
  return <InlineSVG {...props} src={PDFAppIcon} />
}

export function PPTXApp(props) {
  return <InlineSVG {...props} src={PPTXAppIcon} />
}

export function WordApp(props) {
  return <InlineSVG {...props} src={WordAppIcon} />
}

export function ExcelApp(props) {
  return <InlineSVG {...props} src={ExcelAppIcon} />
}

/**
 * New Home icons as of 2024
 */
export function DeliveryFilled(props) {
  return <InlineSVG {...props} src={DeliveryFilledIcon} />
}

/**
 * /New Home icons as of 2024
 */
export function NotReferenced(props) {
  return (
    <InlineSVG
      {...props}
      src={NotReferencedIcon}
      className={(props && props.className) || 'row'}
    />
  )
}

export function Referenced(props) {
  return (
    <InlineSVG
      {...props}
      src={ReferencedIcon}
      className={(props && props.className) || 'row'}
    />
  )
}

export function StarFilledBig(props) {
  return (
    <InlineSVG
      {...props}
      src={StarFilledBigIcon}
      className={props?.className || 'row'}
    />
  )
}

export function StarUnfilledBig(props) {
  return (
    <InlineSVG
      {...props}
      src={StarUnfilledBigIcon}
      className={props?.className || 'row'}
    />
  )
}

export function StarUnfilledInactiveBig(props) {
  return (
    <InlineSVG
      {...props}
      src={StarUnfilledInactiveBigIcon}
      className={props?.className || 'row'}
    />
  )
}

export function ThreeDots(props) {
  return (
    <InlineSVG
      {...props}
      src={ThreeDotsIcon}
      className={props?.className || 'row'}
    />
  )
}

export function DeliveryHeaderBar(props) {
  return (
    <InlineSVG
      {...props}
      src={DeliveryHeaderBarIcon}
      className={props?.className || 'row'}
    />
  )
}

export function LogoDarkSmall(props) {
  return (
    <InlineSVG
      {...props}
      src={LogoDarkSmallIcon}
      className={props?.className || 'row'}
    />
  )
}

export function LogoDark(props) {
  return (
    <InlineSVG
      {...props}
      src={LogoDarkIcon}
      className={props?.className || 'row'}
    />
  )
}

export function StruxHubFull(props) {
  return (
    <InlineSVG
      {...props}
      src={StruxHubFullIcon}
      className={(props && props.className) || 'row'}
    />
  )
}

export function LogoWithTitle(props) {
  return (
    <InlineSVG
      {...props}
      src={LogoWithTitleIcon}
      className={(props && props.className) || 'row'}
    />
  )
}

export function Vendor(props) {
  return (
    <InlineSVG
      {...props}
      src={VendorIcon}
      className={(props && props.className) || 'row'}
    />
  )
}

export function Team(props) {
  return <InlineSVG {...props} src={TeamIcon} />
}

export function Sitemap(props) {
  return <InlineSVG {...props} src={SitemapIcon} />
}

export function DoubleVerticalDots(props) {
  return <InlineSVG {...props} src={DoubleVerticalDotsIcon} />
}

export function File(props) {
  return <InlineSVG {...props} src={FileIcon} />
}

export function List(props) {
  return <InlineSVG {...props} src={ListIcon} />
}

export function Company(props) {
  return <InlineSVG {...props} src={CompanyIcon} />
}

export function CompanyCompact(props) {
  return <InlineSVG {...props} src={CompanyCompactIcon} />
}

export function EyeView(props) {
  return (
    <InlineSVG
      {...props}
      src={EyeViewIcon}
      className={(props && props.className) || 'row'}
    />
  )
}

export function User(props) {
  return (
    <InlineSVG
      {...props}
      src={UserIcon}
      className={(props && props.className) || 'row'}
    />
  )
}

export function Hierarchy(props) {
  return (
    <InlineSVG
      {...props}
      src={HierarchyIcon}
      className={(props && props.className) || 'row'}
    />
  )
}

export function Edit(props) {
  return (
    <InlineSVG {...props} src={EditIcon} className={`row ${props.className}`} />
  )
}

export function DeliveryUpdate(props) {
  return <InlineSVG {...props} src={DeliveryUpdateIcon} className="row" />
}

export function DeliveryNotificationDone(props) {
  return <InlineSVG {...props} src={DeliveryNotificationDoneIcon} />
}

export function DeliveryNotificationInspectionAccepted(props) {
  return (
    <InlineSVG {...props} src={DeliveryNotificationInspectionAcceptedIcon} />
  )
}

export function DeliveryNotificationInspectionRejected(props) {
  return (
    <InlineSVG {...props} src={DeliveryNotificationInspectionRejectedIcon} />
  )
}

export function DeliveryNotificationOnsite(props) {
  return <InlineSVG {...props} src={DeliveryNotificationOnsiteIcon} />
}

export function DeliveryNotificationRequested(props) {
  return <InlineSVG {...props} src={DeliveryNotificationRequestedIcon} />
}

export function DeliveryNotificationScheduled(props) {
  return <InlineSVG {...props} src={DeliveryNotificationScheduledIcon} />
}

export function DeliveryNotificationChanged(props) {
  return <InlineSVG {...props} src={DeliveryNotificationChangedIcon} />
}

export function CheckSolidGrey(props) {
  return <InlineSVG {...props} src={CheckSolidGreyIcon} />
}

export function CheckFillBlue(props) {
  return <InlineSVG {...props} src={CheckFillBlueIcon} />
}

export function DeliveryAccepted(props) {
  return <InlineSVG {...props} src={DeliveryAcceptedIcon} />
}

export function DeliveryPassedInspection(props) {
  return <InlineSVG {...props} src={DeliveryPassedInspectionIcon} />
}

export function DeliveryRequested(props) {
  return <InlineSVG {...props} src={DeliveryRequestedIcon} />
}

export function DeliveryFailedInspection(props) {
  return <InlineSVG {...props} src={DeliveryFailedInspectionIcon} />
}

export function DeliveryDone(props) {
  return <InlineSVG {...props} src={DeliveryDoneIcon} />
}

export function DeliveryOnsite(props) {
  return <InlineSVG {...props} src={DeliveryOnsiteIcon} />
}

export function Truck(props) {
  const className = `row ${props.className || ''}`
  return <InlineSVG {...props} src={TruckIcon} className={className} />
}

export function EditInactive(props) {
  return <InlineSVG {...props} src={EditInactiveIcon} />
}

export function EditActive(props) {
  return <InlineSVG {...props} src={EditActiveIcon} />
}

export function Delivery(props) {
  return <InlineSVG {...props} src={DeliveryIcon} />
}

export function CalendarGrey(props) {
  return <InlineSVG {...props} src={CalendarBlankGrayIcon} />
}

export function CalendarSelectedGrey(props) {
  return <InlineSVG {...props} src={CalendarSelectedGrayIcon} />
}

export function Cross(props) {
  return <InlineSVG {...props} src={CrossIcon} />
}

export function CrossGrey(props) {
  return <InlineSVG {...props} src={CrossGreyIcon} />
}

export function Plus(props) {
  return <InlineSVG {...props} src={PlusIcon} />
}

export function Pdf(props) {
  return <InlineSVG {...props} src={PdfIcon} />
}

export function Clock(props) {
  return <InlineSVG {...props} src={ClockIcon} />
}

export function ProjectDetails(props) {
  return <InlineSVG {...props} src={ProjectDetailsIcon} />
}

export function FilledStar(props) {
  return <InlineSVG className="row" {...props} src={FilledStarIcon} />
}

export function UnfilledStar(props) {
  return <InlineSVG className="row" {...props} src={UnfilledStarIcon} />
}

export function UnfilledStarInactive(props) {
  return (
    <InlineSVG
      {...props}
      src={UnfilledStarInactiveIcon}
      className={(props && props.className) || 'row'}
    />
  )
}

export function StarHalf(props) {
  return (
    <InlineSVG
      {...props}
      src={StarHalfIcon}
      className={(props && props.className) || 'row'}
    />
  )
}

export function Filter(props) {
  return (
    <InlineSVG
      className={(props && props.className) || 'row'}
      {...props}
      src={FilterIcon}
    />
  )
}

export function Material(props) {
  return (
    <InlineSVG
      {...props}
      src={MaterialIcon}
      className={(props && props.className) || 'row'}
    />
  )
}

export function Repeat(props) {
  return <InlineSVG {...props} src={RepeatIcon} />
}

export function CheckPaletteBlue(props) {
  return <InlineSVG {...props} src={CheckPaletteBlueIcon} />
}

export function Mobile(props) {
  return <InlineSVG {...props} src={MobileIcon} />
}

export function BallInCourt(props) {
  return <InlineSVG {...props} src={BallInCourtIcon} />
}

export function Calendar(props) {
  return <InlineSVG {...props} src={CalendarIcon} />
}

export function ArrowNext(props) {
  return <InlineSVG {...props} src={ArrowNextIcon} />
}

export function ArrowForward(props) {
  return <InlineSVG {...props} src={ArrowForwardIcon} />
}

export function ArrowBack(props) {
  return <InlineSVG {...props} src={ArrowBackIcon} />
}

export function Photo(props) {
  return <InlineSVG {...props} src={PhotoIcon} />
}

export function Measure(props) {
  return <InlineSVG {...props} src={MeasureIcon} />
}

export function HashTag(props) {
  return <InlineSVG {...props} src={HashTagIcon} />
}

export function IdIcon(props) {
  return <InlineSVG {...props} src={IdIconSrc} />
}

export function Docs(props) {
  return <InlineSVG {...props} src={DocsIcon} />
}

export function ProcoreLogo(props) {
  return (
    <InlineSVG
      {...props}
      src={ProcoreLogoIcon}
      className={props?.className || 'row'}
    />
  )
}
export function ConcreteDirect(props) {
  return <InlineSVG {...props} src={ConcreteDirectIcon} />
}

export function SharedEntity(props) {
  return (
    <InlineSVG
      {...props}
      src={SharedEntityIcon}
      className={(props && props.className) || 'row'}
    />
  )
}

export function SharedEntityCall(props) {
  return (
    <InlineSVG
      {...props}
      src={SharedEntityCallIcon}
      className={(props && props.className) || 'row'}
    />
  )
}

export function SharedEntityUser(props) {
  return (
    <InlineSVG
      {...props}
      src={SharedEntityUserIcon}
      className={(props && props.className) || 'row'}
    />
  )
}

export function SharedEntityOfficeLabel(props) {
  return (
    <InlineSVG
      {...props}
      src={SharedEntityOfficeLabelIcon}
      className={(props && props.className) || 'row'}
    />
  )
}

export function SharedEntityDotSeparator(props) {
  return (
    <InlineSVG
      {...props}
      src={SharedEntityDotSeparatorIcon}
      className={(props && props.className) || 'row'}
    />
  )
}
